import React, { useEffect, useState } from "react";
import EmptyState from "../components/common/EmptyState";
import ErrorState from "../components/common/ErrorState";
import StudentTable from "../components/student/StudentTable";
import Pagination from "../components/common/Pagination";
import studentService from "../services/studentService";
import universityService from "../services/universityService";

export default function Students() {
  const [rows, setRows] = useState([]);
  const [state, setState] = useState("loading");
  const [search, setSearch] = useState("");
  const [university, setUniversity] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ totalPages: 1 });
  const [universities, setUniversities] = useState([]);

  useEffect(() => {
    universityService.list({ limit: 100 }).then((res) => setUniversities(res.data || [])).catch(() => {});
  }, []);

  function load() {
    setState("loading");
    studentService
      .list({ search, university_name: university, is_active: status, page, limit: 10 })
      .then((res) => {
        setRows(res.data || []);
        setPagination(res.pagination || { totalPages: 1 });
        setState((res.data || []).length ? "ready" : "empty");
      })
      .catch(() => setState("error"));
  }

  useEffect(load, [page, university, status]); // eslint-disable-line
  useEffect(() => {
    const t = setTimeout(() => { setPage(1); load(); }, 350);
    return () => clearTimeout(t);
  }, [search]); // eslint-disable-line

  return (
    <div className="pm-page">
      <header className="pm-page__header">
        <div>
          <span className="pm-eyebrow">Applicants</span>
          <h1>Students</h1>
        </div>
      </header>

      <div className="pm-toolbar">
        <input
          className="pm-search"
          placeholder="Search name, ID, email, university…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <select value={university} onChange={(e) => { setPage(1); setUniversity(e.target.value); }}>
          <option value="">All campuses</option>
          {universities.map((u) => (
            <option key={u.id} value={u.name}>{u.name}</option>
          ))}
        </select>
        <select value={status} onChange={(e) => { setPage(1); setStatus(e.target.value); }}>
          <option value="">All statuses</option>
          <option value="1">Active</option>
          <option value="0">Inactive</option>
        </select>
      </div>

      {state === "error" && <ErrorState onRetry={load} />}
      {state === "empty" && <EmptyState title="No students found" description="Try adjusting your filters." />}
      {(state === "ready" || state === "loading") && (
        <>
          <div className="pm-card">
            <StudentTable students={rows} loading={state === "loading"} />
          </div>
          <Pagination page={page} totalPages={pagination.totalPages} onChange={setPage} />
        </>
      )}
    </div>
  );
}
